import React from "react";
import Axios from "axios";
import Swal from "sweetalert2";
import { useState } from "react";

export default function Visitorform() {
  const url = "http://localhost:3002/api/v1/Visitor";
  const [formData, setformData] = useState({
    name: "",
    email: "",
    company: "",
    contact: "",
    message: "",
    // date: { moment },
  });

  function submit(e) {
    e.preventDefault();
    Axios.post(url, {
      name: formData.name,
      email: formData.email,
      companyname: formData.company,
      contactnumber: parseInt(formData.contact),
      message: formData.message,
    }).then((res) => {
      if (res["status"]) {
        console.log("-----------------");
        let clearObj = {
          name: "",
          email: "",
          company: "",
          contact: "",
          message: "",
          // date: { moment },
        };

        setformData(clearObj);
      } else {
      }
      // console.log(res.formData);
    });
  }

  function handle(e) {
    let newdata = { ...formData };
    newdata[e.target.id] = e.target.value;
    setformData(newdata);
    console.log(newdata);
  }

  const successAlert = () => {
    Swal.fire({
      title: "Form Submitted Successfully!",
      text: "ckeck your mail.",
      icon: "success",
    });
  };

  return (
    <>
      <div className="col-md-6">
        <form onSubmit={(e) => submit(e)} id="visitorForm">
          <div className="col-md-10">
            <div className="row ">
              <div className=" form-group">
                <input
                  onChange={(e) => handle(e)}
                  value={formData.name}
                  type="text"
                  name="name"
                  className="form-control"
                  id="name"
                  placeholder="Your Name"
                  required
                />
              </div>

              <div className=" form-group">
                <input
                  onChange={(e) => handle(e)}
                  value={formData.email}
                  type="email"
                  className="form-control"
                  name="email"
                  id="email"
                  placeholder="Your Email"
                  required
                />
              </div>

              <div className=" form-group">
                <input
                  onChange={(e) => handle(e)}
                  value={formData.company}
                  type="text"
                  className="form-control"
                  name="company"
                  id="company"
                  placeholder="Company Name"
                  required
                />
              </div>
              <div className=" form-group">
                <input
                  onChange={(e) => handle(e)}
                  value={formData.contact}
                  type="text"
                  className="form-control"
                  name="contact"
                  id="contact"
                  placeholder="contact Number"
                  required
                />
              </div>
              <div className=" form-group">
                <textarea
                  onChange={(e) => handle(e)}
                  value={formData.message}
                  className="form-control"
                  id="message"
                  name="message"
                  rows="4"
                  placeholder="Message"
                  required
                ></textarea>
              </div>

              <div className="text-center">
                <button
                  onChange={(e) => submit(e)}
                  onClick={successAlert}
                  type="submit"
                  className="btm btn-orange"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
